module.exports = __webpack_public_path__ + "img/cxlyxglrj_banner.5696aa70.png";